import {cn} from '@/lib/utils';
interface Props {
  className?: string;
}

export default function Bath({className}: Props) {
  return (
    <svg
      className={cn('fill-current text-gray-500', className)}
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="20"
      viewBox="0 0 24 20">
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M22 10.444c1.737.768 2 1.556 2 1.556v8h-2v-2H2v2H0v-8s.263-.788 2-1.556V0h2v3h16V0h2v10.444zm-2-.666V5h-7v4.009c3.138.054 5.389.366 7 .769zm-16 0c1.611-.403 3.862-.715 7-.77V5H4v4.778zM22 16v-3s-2-2-10-2-10 2-10 2v3h20z"
      />
    </svg>
  );
}
